import music from "../Data/Music.json";
import React, { useState} from 'react';
import MusicCards from "./MusicCards";
import { Modal, Button, Form } from 'react-bootstrap';
import AdPopUp from "./AdPopUp";
import { Link } from "react-router-dom";
import picture2 from '../Data/Flakes.jpeg';
import picture3 from '../Data/BrakePads.jpg';


function MyVerticallyCenteredModal(props) {
    
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    Enter your email address to sign up for notifications for new songs AND get 20% off our monthly PREMIUM subscription!
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>Email address</Form.Label>
                    <Form.Control type="email" onChange={(e) => props.changeHandler(e)} placeholder="Enter email" />
                    <Form.Text className="text-muted">
                    We'll never share your email with anyone else.
                    </Form.Text>
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={props.email && props.onHide}>Submit</Button>
                <button onClick={props.onHide}>I would rather pay the more expensive price</button>
            </Modal.Footer>
        </Modal>
    );
}

function PremiumModal(props) {
    
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Cob's Soul Music
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    Want EXCLUSIVE songs that only YOU will have access to? Sign up for Cob's <strong>PREMIUM</strong> membership today!
                </p>
            </Modal.Body>
            <Link to="/Checkout">
            <Modal.Footer>
            <Button onClick={props.onHide}>Continue to Checkout</Button>
            </Modal.Footer>
            </Link>
        </Modal>
    );
}

function AdPopUp2() {
    
    const [adShow, setAdShow] = useState(true)

    return(
        <>
            <Modal show={adShow} onHide={() => setAdShow(false)}>
                <Modal.Body>
                    <div className="card text-white bg-info mb-3" style={{max_width: "20rem"}} >
                        <div className="card-header">Cereal Flakes</div>
                        <div className="card-body">
                            <img className ="Bucksimage" src={picture2} style={{ height: "40%", width: "90%"}}/>
                            <h4 className="card-title">
                                
                            </h4>
                            <p className="card-text">"Abestos free"</p>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}

function AdPopUp3() {
    
    const [adShow, setAdShow] = useState(true)    

    return(
        <>
            <Modal show={adShow} onHide = {() => setAdShow(false)}>
                <Modal.Body>
                    <div className="card text-white bg-info mb-3" style={{max_width: "20rem"}} >
                        <div className="card-header">Jim's Brake Pads</div>
                        <div className="card-body">
                            <img className ="Bucksimage" src={picture3} style={{ height: "40%", width: "90%"}}/>
                            <h4 className="card-title">
                            
                                
                            </h4>
                            <p className="card-text">“They work every time, 50% of the time”</p>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}

function DarkSoulMusic() {
    const [genre, setGenre] = useState("");
    const [email, setEmail] = useState("");
    const [artist, setArtist] = useState("");
    const [decade, setDecade] = useState("");
    const [data, setData] = useState([]);
    const [modalShow, setModalShow] = useState(true);
    const [premiumShow, setPremiumShow] = useState(false)
    
    console.log(music)

    
    
    const changeHandler = (e) => {
        console.log('email value change', e.target.value);
        setEmail(e.target.value);
    }

    const getFavor = () => {
        console.log('music data', JSON.parse(localStorage.getItem('music')));
        setData(JSON.parse(localStorage.getItem('music')) || []);
    }

    return (
        <>
            <div style={{ display: "grid" }}>
                <h1 style={{ gridColumn: 2, gridRow: 1, textAlign: "center" }}>
                    Cob's Soul Music
                </h1>
                <p style={{ gridColumn: 2, gridRow: 2, textAlign: "center" }}>
                    Welcome to Cob's very own music website! We have a lot of songs in store, so keep on jammin! Press Show All in the My-Favorites dropdown to see the songs you favorited
                </p>
                <p style={{ gridColumn: 2, gridRow: 3, textAlign: "center" }}>
                    If you want to listen to more awesome music with Cob's, please consider buying a monthly subscription to COBS PREMIUM!
                </p>


                {/* <button style={{ gridColumn: 3, gridRow: 1 }}>My Favorites</button> */}
                <div style={{ gridColumn: 3, gridRow: 1 }}>
                    <select onChange={() => getFavor()}>
                        <option value="">My Favorites</option>
                        <option value="">Show All</option>
                        {data && data.length && data.map((favor) => (
                            <>
                                <option value={favor}>{favor}</option>
                            </>
                        ))}
                    </select>
                </div>
            </div>
            <div>
                <label>Decade</label>
                <select onChange={(e) => setDecade(e.target.value)}
                    value={decade}>
                    <option value="">Show All</option>
                    {Array.from(new Set(music.map((track) => track.decade))).map((decade) => <option value={decade}>{decade}</option>)
                    }
                </select>
                <label>Genre</label>
                <select onChange={(e) => setGenre(e.target.value)}
                    value={genre}>
                    <option value="">Show All</option>
                    {Array.from(new Set(music.map((track) => track.genre))).map((genre) => <option value={genre}>{genre}</option>)
                    }
                </select>
                <label>Artist</label>
                <select onChange={(e) => setArtist(e.target.value)}
                    value={artist}>
                    <option value="">Show All</option>
                    {Array.from(new Set(music.map((track) => track.artist))).map((artist) => <option value={artist}>{artist}</option>)
                    }
                </select>
            </div>
            <p>
                <strong>
                There are 100 other people playing music with you right now!
                </strong>
            </p>
            <MyVerticallyCenteredModal
                show={modalShow}
                onHide={() => setModalShow(false)}
                changeHandler={(e) => changeHandler(e)}
                email={email}
            />
            <PremiumModal
                show={premiumShow}
                onHide={() => setPremiumShow(false)}
            />
            <AdPopUp
                
            />
            <AdPopUp2

            />
            <AdPopUp3

            />
            {
                music.filter(track => (track.genre === genre || genre === "") && (track.artist === artist || artist === "")).map(track => <MusicCards track={track} setPremiumShow={setPremiumShow} />)
            }
           
        </>
    );
}

export default DarkSoulMusic;